import MoreButton from './MoreButton';
import MoreButtonContainer from './MoreButton.container';
export default MoreButtonContainer(MoreButton);
//# sourceMappingURL=index.js.map